import { WarehouseContactTabProps } from "./types";
import { memo, useCallback, useState } from "react";
import {
  useHandleDropdownChange,
} from "services/forms/hooks";
import { useTranslate } from "helpers";
import ContactDropdown from "ui/components/Dropdown/ContactDropdown/ContactDropdown";
import { Button } from "ui/components/Button/Button";
import { Errors } from "services/forms/validation/types";
import { FleetWarehouseContactFormValues } from "services/api/fleet/warehouses/types";
import { Contact } from "services/api/contacts/types";
import { getContactAPI } from "services/api/contacts/api";
import { initialFleetWarehouseContactForm } from "services/api/fleet/warehouses/consts";
import WarehouseContactList from "./components/WarehouseContactList";

const WarehouseContactTab: React.FC<WarehouseContactTabProps> = (props) => {
  const { formValues, setFormValues } = props;


  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<Errors>({});
  const [contactFormValues, setContactFormValues] =
    useState<FleetWarehouseContactFormValues>(initialFleetWarehouseContactForm);

  const { t } = useTranslate();

  const handleContactAddClick = useCallback(
    async (e: any) => {
      e.preventDefault();

      if (!contactFormValues?.contactId) {
        setErrors({ contactId: "Molimo Vas da odaberete kontakt" });
        return;
      }

      setIsLoading(true);

      let result: Contact;
      try {
        result = await getContactAPI(contactFormValues?.contactId);

        if (result) {
          setFormValues((prev) => ({
            ...prev,
            contacts: [...prev.contacts, result],
          }));
          // setFormValues((prev) => ({
          //   ...prev,
          //   contacts: [
          //     ...prev.contacts,
          //     {
          //       ...result,
          //       contactId: result.id,
          //     },
          //   ],
          // }));

          setContactFormValues(initialFleetWarehouseContactForm);
        }
      } catch {
        setIsLoading(false);
        return;
      }
    },
    [setContactFormValues, contactFormValues]
  );

  const handleRemoveRowClick = useCallback((index: number) => {
    setFormValues((prev) => ({
      ...prev,
      contacts: prev.contacts.filter((_, i) => i !== index),
    }));
  }, []);

  const handleDropdownChange = useHandleDropdownChange(
    setContactFormValues,
    contactFormValues
  );

  const contacts = formValues.contacts;

  return (
    <div className="border border-slate-300 rounded-sm px-4 pt-4 pb-4 -mt-[1px]">
      <div className="flex gap-3 mb-4 items-end">
        <div className="flex-1">
          <ContactDropdown
            placeholder={t("admin.fleet.warehouse.add.contact.placeholder")}
            label={t("admin.fleet.warehouse.add.contact")}
            name="contactId"
            value={contactFormValues?.contactId}
            onChange={handleDropdownChange}
            error={errors.contactId}
            required
          />
        </div>
        <Button
          variant="primary"
          onClick={handleContactAddClick}
          startIcon="/media/icons/plus.svg"
        >
          Dodaj na skladište
        </Button>
      </div>
      <WarehouseContactList
        contacts={contacts}
        onRemove={handleRemoveRowClick}
      />
    </div>
  );
};
export default memo(WarehouseContactTab);
